import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import {
  catchError,
  filter,
  map,
  of,
  retryWhen,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs';

import { retryStrategy } from '@personal-area/global/http/services';
import { UserFacade } from '@personal-area/global/users/services';

import { TariffService } from '../../services/tariff.service';
import {
  GetTariffs,
  GetTariffsFail,
  GetTariffsSuccess,
  SetTariffsLoading,
} from '../actions/tariffs';
import { TariffState } from '../reducers/tariffs';
import { areTariffsLoaded, areTariffsLoading } from '../selectors/tariffs';

@Injectable()
export class TariffsEffects {
  constructor(
    private _store: Store<TariffState>,
    private _actions$: Actions,
    private _userFacade: UserFacade,
    private _tariffsService: TariffService,
  ) {}

  getTariffs$ = createEffect(() =>
    this._actions$.pipe(
      ofType(GetTariffs),
      withLatestFrom(
        this._store.select(areTariffsLoading),
        this._store.select(areTariffsLoaded),
        (action, areTariffsLoading, areTariffsLoaded) =>
          areTariffsLoading === false && areTariffsLoaded === false,
      ),
      filter(Boolean),
      tap(() => this._store.dispatch(SetTariffsLoading())),
      switchMap(() =>
        this._tariffsService
          .fetchTariffs(
            Boolean(this._userFacade.loggedUser.referralLinkParams) ||
              this._userFacade.loggedUser.isPartner,
          )
          .pipe(
            retryWhen(retryStrategy()),
            map((tariffs) => GetTariffsSuccess(tariffs)),
            catchError((error) => of(GetTariffsFail(error))),
          ),
      ),
    ),
  );
}
